<div *ngIf="orderedProducts"
     [class.return-modal-show]="isFormationRequestReturn"
     [class.return-modal-hide]="!isFormationRequestReturn">
  <a class="close-modal" (click)="closeModal()"></a>
  <h3 class='text-center'>Формування заяви на повернення до замовлення №{{ currentOrder.id }}</h3>
  <table class='return_data'>
    <thead>
    <tr>
      <th>Найменування</th>
      <th>Фасовка</th>
      <th>Артикул</th>
      <th>Кіл-ть</th>
    </tr>
    </thead>
    <tbody *ngFor="let op of orderedProducts; index as i">
    <tr *ngIf="op.checkedReturned">
      <td>{{ op.name }}</td>
      <td>{{ op.pack }}</td>
      <td>{{ op.firstArticle }}</td>
      <td>
        <input [(ngModel)]="op.count" type='number' class="input-quantity"
               [class.input-quantity-good]="op.count > op.countMax || op.count <= 0 || op.count === null" min="1"
               [max]="op.countMax">
        <span *ngIf="op.count > op.countMax"
              class="comment-text">{{ errorMessageQuantityMaxGood }} {{ op.countMax }}</span>
        <span *ngIf="op.count <= 0 || op.count === null" class="comment-text">{{ errorMessageQuantityMinGood }}</span>
      </td>
    </tr>
    </tbody>
  </table>
  <div class='row'>
    <textarea [class.comment-error]="wrongComment"
              [(ngModel)]="returnComment"
              (input)="inputComment()"
              class="textarea-style"
              placeholder='Увага! Обов’язково прописати  номер ТТН у разі повернення через перевізника. Коментар.'
    >
    </textarea>
  </div>
  <div class="comment-text">
    <span [class.comment-message]="!wrongComment">{{ errorCommentMessage }}</span>
  </div>

  <div class='row-select'>
    <div class='shrink'>
      <select [class.comment-error]="wrongSelect"
              [(ngModel)]="statusId"
              (change)="changingValue(statusId)"
      >
        <option value="0">Виберіть причину повернення</option>
        <option [value]="rs.id" *ngFor="let rs of returnStatuses">
          {{ rs.name }}
        </option>
      </select>
    </div>

    <div class="row mobile-version">
      <span class="comment-text" [class.comment-message]="!wrongSelect">{{ errorReasonForReturnMessage }}</span>
    </div>

    <div *ngIf="statusId === '4'" class='shrink'>
      <select class="select-style"
              [class.comment-error]="wrongSelectDate"
              [(ngModel)]="dateDelivery"
              (change)="selectDeliveryDate()"
      >
        <option value="0">Поміняти дату доставки, відправки, самовивіз</option>
        <option [value]="delDate" *ngFor="let delDate of deliveryDates">
          {{ delDate }}
        </option>
      </select>
    </div>

    <div class="row mobile-version">
      <span class="comment-text" [class.comment-message]="!wrongSelectDate">{{ errorDeliveryDateMessage }}</span>
    </div>

    <div class='shrink'>
      <button type='submit' class='button' [disabled]="isSubmitting" (click)="submitFormGoodReturn()">Сформувати заяву на повернення</button>
    </div>
  </div>
  <div class="row desktop-version">
    <span class="comment-text" [class.comment-message]="!wrongSelect">{{ errorReasonForReturnMessage }}</span>
    <div class="wrong-date-delivery-message">
      <span class="comment-text" [class.comment-message]="!wrongSelectDate">{{ errorDeliveryDateMessage }}</span>
    </div>
  </div>
</div>

<div class="dark-layer"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
